export default "__VITE_ASSET__BEW0PtCr__"